<template>
  <div>
  <div class="typed-on-paper-a4">
    <div class="text-align-center">
      <h1>CAMPAIGN SKINS</h1>
    </div>
    <br><br>
    <div class="">
      <p class="text-align-left">
        The "Flying Tin Cans" are currently using Haluter's brilliant Skin Downloader (HSD) software to distribute our custom skins.
        More details, instructions and troubleshooting tips can be found <!-- TODO: activate again <a href="./assets/HSD_for_FTC_skinner_manual.pdf"> here--></a>.
      </p>
      <h2>Installation</h2>
      <ul style="margin-left: 2em">
        <li>Download HSD.zip at https://skins.combatbox.net/HSD.zip</li>
        <li>Copy the folder “HSD for IL2 GB” and place it where you would like HSD to install.
          Make sure your drive has some space available as HSD needs to download preview images. </li>
        <li>Open the folder and start HSD.exe. </li>
        <li>Read the EULA** carefully and click "I Agree" if you agree. </li>
        <li>In the start-up window, locate and add your IL-2 Skins folder folder.
          (...\IL-2 Sturmovik Battle of Stalingrad\data\graphics\skins) If you use IL-2 through steam, the folder is detected automatically. </li>
        <li>Wait for HSD to finish downloading and click “Continue”.  </li>
        <li>You will probably get a request to update HSD, do this to get the latest version.  </li>
        <li>You are now ready to use it. </li>
      </ul>
      <p>* An internet connection is required to install and use HSD. </p>
      <p>** HSD MUST BE RUN WITH ADMINISTRATOR RIGHTS AT ALL TIMES.</p>
      <h2>HSD in the "Flying Tin Cans"</h2>
      <p>The first thing to understand here is that editing skins is not possible in HSD.
      The skinner will have to request to remove an old version in the HSD Discord, for a curator to upload
      the new version.</p>
      <p>Rostic has created two guides that will show you how to use HSD in the context of its use for the
      "Flying Tin Cans".</p>
      <iframe style="border-radius: 25px" id="ytplayer" type="text/html" width="49%" height="150px" src="https://www.youtube.com/embed/zv6bnOOtwb0"
      frameborder="0"></iframe>
      <iframe style="border-radius: 25px" id="ytplayer" type="text/html" width="49%" height="150px" src="https://www.youtube.com/embed/8OIzitlIHPw"
              frameborder="0"></iframe>
      <p>For now, we will be using only 4K skins, with 2K skins being reserved for skins created without a template.</p>
      <p>The priority is to create censored skins, and optionally uncensored skins (i.e. with the swastika).
      Victory markings, or nose-art that includes the swastika are also considered uncesored skins.</p>
    </div>
  </div>
  </div>
</template>

<script>

  export default {
    name: "InfoTemplate"
  }
</script>

<style scoped>

.iconImage {
  max-height: 40px;
}

.navbar-tabs {
  min-height: 0px;
  width: calc(100% - 0px); /* Whished widht in % minus 2x border size */
  padding: 20px;
  padding-bottom: 15px;
  font-family: "Remingtoned Type";
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  background-image: url("/frontend/src/assets/images/ftcpaper.png");
  /*background: linear-gradient(90deg, #ebebe9 1px, #ebe6e6 1px, #efeeec 1px, #e7e6e4 1px, #eae6e5 1px);*/
  box-shadow: 0px -5px 15px rgba(10,10,10,0.3);
  color: #1b1b1b;
}

.navigationList li {
  display: table-cell;
  font-size: 125%;
  text-align: center;
}

.navigationList li a {
  padding: 0px 40px;
  text-decoration: none;
  font-weight: bold;
  color: #1b1b1b;
}

.navigationList li a:hover{
  color: #1b1b1b;
  background: rgba(255, 255, 255, 0.5);
  border-color: #646464;
  border-radius: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/info/CampaignSkins.vue